import { kebabCase } from 'es-toolkit/compat';
import type { ContentTableItem } from './components/content-table-items/content-table-items';

/** Every heading this builds is seeded with a `subtitle` array to push into. */
type HeadingItem = ContentTableItem & {
  subtitle: NonNullable<ContentTableItem['subtitle']>;
};

export function filterHeadingsAndDescendants(
  array: { type: string; text: string }[],
): ContentTableItem[] {
  const result: HeadingItem[] = [];
  let currentSubtitle: HeadingItem | undefined;

  for (const item of array) {
    if (item.type === 'heading2') {
      currentSubtitle = {
        href: kebabCase(item.text),
        name: item.text,
        subtitle: [],
      };
      result.push(currentSubtitle);
    } else if (item.type === 'heading3' && currentSubtitle) {
      currentSubtitle.subtitle.push({
        href: kebabCase(item.text),
        name: item.text,
      });
    }
  }
  return result;
}
